import { Flex, Image } from '@mantine/core';

import { Text } from 'components';
import { AppConstants } from '../constants';

const { LOCK_PNG } = AppConstants;

const EncodedHeader = ({ t }: any) => {
  return (
    <Flex direction={'row'} align={'center'} justify={'center'} mt={30}>
      <Image src={LOCK_PNG} style={{ height: 16, width: 16 }} />
      <Text size={'sm'} style={{ textAlign: 'center' }}>{t('data.encoded')}</Text>
    </Flex>
  )
}

export default EncodedHeader;